export default __webpack_public_path__ + "1c607d657e586e8b10484152bc09c418.png";